import { Component, input } from '@angular/core';

@Component({
  selector: 'app-pan-national-indicator',
  templateUrl: './pan-national-indicator.component.html',
  styleUrl: './pan-national-indicator.component.scss',
  standalone: false,
})
export class PanNationalIndicatorComponent {
  public isNational = input<boolean>(true);
}
